// frontend/src/components/common/Header.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import LogoutButton from "../../portal/LogoutButton";

const Header = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Lock/unlock body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen && isMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen, isMobile]);

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <>
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <img
              src="/images/dangle.png"
              alt="Life is Good"
              className="header-avatar"
              onClick={() => handleNavigation("/")}
            />

            {/* Desktop Navigation */}
            <div className="desktop-nav">
              <button
                onClick={() => handleNavigation("/")}
                className="header-nav-btn"
              >
                Life is good
              </button>
              <button
                onClick={() => handleNavigation("/years")}
                className="header-nav-btn"
              >
                Year in review
              </button>
              <button
                onClick={() => handleNavigation("/invite")}
                className="header-nav-btn"
              >
                Invite
              </button>
            </div>
          </div>

          <div className="header-right">
            {/* Desktop Logout */}
            <div className="desktop-logout">
              <LogoutButton />
            </div>

            {/* Mobile Hamburger */}
            <button
              className={`hamburger ${isMenuOpen ? "open" : ""}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && isMobile && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <nav className="mobile-nav">
          <button
            onClick={() => handleNavigation("/")}
            className="mobile-nav-btn"
          >
            Life is good
          </button>
          <button
            onClick={() => handleNavigation("/years")}
            className="mobile-nav-btn"
          >
            Year in review
          </button>
          <button
            onClick={() => handleNavigation("/invite")}
            className="mobile-nav-btn"
          >
            Invite
          </button>
          <div className="mobile-logout">
            <LogoutButton />
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
